/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Cursors are opaque. Follow the tokens the server returns; never construct, parse or modify one.
 * @export
 * @interface APICursorPagination
 */
export interface APICursorPagination {
    /**
     * 
     * @type {number}
     * @memberof APICursorPagination
     */
    limit: number;
    /**
     * Opaque token addressing the next page. Absent on the last page.
     * @type {string}
     * @memberof APICursorPagination
     */
    next_cursor?: string;
    /**
     * Opaque token addressing the previous page. Absent on the first page.
     * @type {string}
     * @memberof APICursorPagination
     */
    prev_cursor?: string;
    /**
     * Opaque token addressing the final page directly, so a client can jump to the end without a total count.
     * @type {string}
     * @memberof APICursorPagination
     */
    last_cursor: string;
    /**
     * Total number of matching items. Returned on the FIRST page only; clients cache it for the remainder of the walk.
     * @type {number}
     * @memberof APICursorPagination
     */
    total_count?: number;
}

/**
 * Check if a given object implements the APICursorPagination interface.
 */
export function instanceOfAPICursorPagination(value: object): value is APICursorPagination {
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('last_cursor' in value) || value['last_cursor'] === undefined) return false;
    return true;
}

export function APICursorPaginationFromJSON(json: any): APICursorPagination {
    return APICursorPaginationFromJSONTyped(json, false);
}

export function APICursorPaginationFromJSONTyped(json: any, ignoreDiscriminator: boolean): APICursorPagination {
    if (json == null) {
        return json;
    }
    return {
        
        'limit': json['limit'],
        'next_cursor': json['next_cursor'] == null ? undefined : json['next_cursor'],
        'prev_cursor': json['prev_cursor'] == null ? undefined : json['prev_cursor'],
        'last_cursor': json['last_cursor'],
        'total_count': json['total_count'] == null ? undefined : json['total_count'],
    };
}

export function APICursorPaginationToJSON(json: any): APICursorPagination {
    return APICursorPaginationToJSONTyped(json, false);
}

export function APICursorPaginationToJSONTyped(value?: APICursorPagination | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'limit': value['limit'],
        'next_cursor': value['next_cursor'],
        'prev_cursor': value['prev_cursor'],
        'last_cursor': value['last_cursor'],
        'total_count': value['total_count'],
    };
}

